export default __webpack_public_path__ + "static/media/dk.d83d2b98.svg";